export default "__VITE_ASSET__DV8zIW3t__"